import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { fetchAllRfidByRackId } from "../../resources/RfidResource";
import { fetchAllWarehouse } from "../../resources/WarehouseResource";
import DataTable from 'react-data-table-component';
import { fetchAllRack } from "../../resources/RackResource";
import { format } from "date-fns";

function VisualizationDetail() {
    const id = useParams();
    const [warehouseIdFilter, setWarehouseIdFilter] = useState(id.warehouse);
    const [rackIdFilter, setRackIdFilter] = useState(id.id);
    const [dataRfid, setDataRfid] = useState([]);
    const [dataWarehouse, setDataWarehouse] = useState([]);
    const [dataRack, setDataRack] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);

    const fetchRfid = () => {
        fetchAllRfidByRackId(rackIdFilter)
            .then((res) => {
                setDataRfid(res.data);
            })
            .catch((err) => {
                setDataRfid([]);
            });
    };

    const fetchWarehouse = () => {
        fetchAllWarehouse()
            .then((res) => {
                setDataWarehouse(res.data);
            })
            .catch((err) => {
                setDataWarehouse([]);
            });
    };

    const fetchRack = () => {
        fetchAllRack()
            .then((res) => {
                setDataRack(res.data);
            })
            .catch((err) => {
                setDataRack([]);
            });
    };

    useEffect(() => {
        fetchRack();
        fetchWarehouse();
        fetchRfid();
        // eslint-disable-next-line
    }, [refreshKey]);

    let filteredRack = dataRack.filter(item => {
        // eslint-disable-next-line
        return item.warehouse_id == warehouseIdFilter;
    });

    const onChangeHandlerWarehouseFilter = async (e) => {
        const index = e.target.selectedIndex;
        const el = e.target.childNodes[index];
        const option = el.getAttribute("id");
        setWarehouseIdFilter(option);

        let selected = dataRack.filter(item => {
            // eslint-disable-next-line
            return item.warehouse_id == option;
        });

        if (selected.length !== 0) {
            setRackIdFilter(selected[0].id);
            setRefreshKey(refreshKey => refreshKey + 1);
        } else {
            setDataRfid([]);
        }

    };

    const onChangeHandlerRackFilter = (e) => {
        const index = e.target.selectedIndex;
        const el = e.target.childNodes[index];
        const option = el.getAttribute("id");

        setRackIdFilter(option);

        setRefreshKey(refreshKey => refreshKey + 1);
    };

    const columns = [
        {
            name: 'No',
            cell: (row, index) => index + 1,
            width: '60px'
        },
        {
            name: 'RFID',
            selector: row => row.rfid_number,
            sortable: true,
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Part No',
            selector: row => row.part_number,
            sortable: true,
        },
        {
            name: 'Part Name',
            selector: row => row.part_name,
            sortable: true,
        },
        {
            name: 'Batch',
            selector: row => row.batch,
            sortable: true,
        },
        {
            name: 'Production Date',
            selector: row => format(row.production_date, "yyyy-MM-dd").toString(),
            sortable: true,
            width: '150px'
        },
        {
            name: 'QTY',
            selector: row => row.qty,
            sortable: true,
            width: '80px'
        },
    ];

    return (
        <div className="page-content-wrapper">
            <div className="page-content">
                <div className="card">
                    <div className="card-body">
                        <div className="card-title">
                            <div className="row gy-3">
                                <div className="col">
                                    <h4 className="mb-0">Rack Data Storage</h4>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-md-3">
                                <label className="form-label">Warehouse :</label>
                                <select className="form-select mb-3" aria-label="Default select example"
                                    value={warehouseIdFilter}
                                    onChange={(e) => onChangeHandlerWarehouseFilter(e)}>
                                    {
                                        dataWarehouse.map((data) => {
                                            return (<option id={data.id}
                                                key={data.id}
                                                value={data.id}>{data.name}</option>);
                                        })
                                    }
                                </select>
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Rack :</label>
                                <select className="form-select mb-3" aria-label="Default select example"
                                    value={rackIdFilter}
                                    onChange={(e) => onChangeHandlerRackFilter(e)}>
                                    {
                                        filteredRack.map((data) => {
                                            return (<option id={data.id}
                                                key={data.id}
                                                value={data.id}>{data.name}</option>);
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                        <br />
                        <div className="table-responsive">
                            <DataTable
                                columns={columns}
                                data={dataRfid}
                                pagination
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VisualizationDetail;